import moment from 'moment-timezone'
import _ from 'lodash'

export function unixToDateTime (timestamp) {
  return moment
    .unix(timestamp)
    .utc()
    .tz('Asia/Hong_Kong')
    .format('YYYY-MM-DD HH:mm:ss')
}

export function downloadFromBlob (data, name) {
  const fileURL = window.URL.createObjectURL(new Blob([data]))
  const fileLink = document.createElement('a')

  fileLink.href = fileURL
  fileLink.setAttribute('download', name)
  document.body.appendChild(fileLink)

  fileLink.click()

  document.body.removeChild(fileLink)
}

export function resolveErrorMessage (error) {
  if (error.response && error.response.data && error.response.data.message) {
    const msg = error.response.data.message
    const data = error.response.data.data

    if (typeof data === 'string') {
      return data
    }

    if (msg !== 'Invalid request data') {
      return msg
    }
    return _.values(data).flat().join('<br>') || msg
  }

  if (error.message) {
    return error.message
  }

  return error.toString()
}

export function validateEmail (email) {
  // eslint-disable-next-line
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(email).toLowerCase())
}

export function resolveLaravelClassBaseName (name) {
  return name.split('\\').reverse()[0]
}

export function filterKeyWithNullValue (data) {
  return Object.entries(data).reduce((obj, [key, value]) => {
    if (value) {
      obj[key] = value
    }
    return obj
  }, {})
}

export function urlJoin (...paths) {
  return paths.reduce((accumulator, path) => {
    let prefix = _.trimEnd(accumulator, '/')
    if (prefix) {
      prefix += '/'
    }
    return prefix + _.trimStart(path, '/')
  }, '')
}



// WEBPACK FOOTER //
// ./src/helper.js